var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sport-btn",on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false},"click":_vm.chooseSportType}},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.activeIcon(_vm.sport.id),"alt":`sport${_vm.sport.id}`}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.sport.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }